import { inject } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { ImportService } from 'pages/utilities/imports/service';
import * as FilePond from 'filepond';

@inject(DialogController, ImportService)
export class RawMaterialImport {
    constructor(controller, importService) {
        this.controller = controller;
        this.importService = importService;

        this.testRan = false;
        this.importRan = false;
    }

    attached() {
        this.fileDrop = FilePond.create(this.fileInput);
        this.fileDrop.on('addfile', (error, file) => {
            this.csv = file.file;
            this.response = null;
            this.testRan = false;
        });
    }

    async importCheck() {
        if (this.response != null && this.response.errors.length == 0) {
            await this.import();
        } else {
            await this.testImport();
        }
    }

    async testImport() {
        if (this.isRequesting || this.csv == null) return;
        this.isRequesting = true;
        this.response = await this.importService.testRawMaterialImport(this.csv);
        this.isRequesting = false;
        this.testRan = true;
    }

    async import() {
        if (this.isRequesting || this.csv == null) return;
        this.isRequesting = true;
        this.response = await this.importService.importRawMaterial(this.csv);
        this.importRan = true;
        this.isRequesting = false;
    }
}